import { X } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";

const PROBLEMS = ["Random Workouts", "Confusing Diets", "Unrealistic Transformations", "Expensive Programs", "Temporary Solutions"];
const PRINCIPLES = ["Simple", "Structured", "Affordable", "Accessible", "Sustainable"];

export const Manifesto = () => {
  return (
    <section id="philosophy" className="relative bg-[#0b1528] py-24 sm:py-32 px-5 sm:px-8" data-testid="manifesto-section">
      <div className="max-w-6xl mx-auto">
        <ScrollReveal>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">The Manifesto</span>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl text-white mt-4 max-w-3xl leading-tight">
            This Is Not A 30-Day Challenge. This Is A Lifestyle System.
          </h2>
        </ScrollReveal>

        <div className="grid lg:grid-cols-2 gap-8 mt-14">
          <ScrollReveal className="glass-card rounded-2xl p-8">
            <h3 className="font-display font-bold text-sm uppercase tracking-widest text-slate-500 mb-6">
              The Fitness Industry Made Health Complicated
            </h3>
            <ul className="space-y-4">
              {PROBLEMS.map((p) => (
                <li key={p} className="flex items-center gap-3 text-slate-400 text-sm sm:text-base" data-testid={`manifesto-problem-${p.toLowerCase().replace(/\s+/g, "-")}`}>
                  <X size={16} className="text-rose-500/70 shrink-0" /> {p}
                </li>
              ))}
            </ul>
          </ScrollReveal>

          <ScrollReveal delay={0.15} className="rounded-2xl p-8 bg-gradient-to-br from-cyan-500/10 to-blue-600/5 border border-cyan-500/25">
            <h3 className="font-display font-bold text-sm uppercase tracking-widest text-cyan-400 mb-6">
              We Believe Health Should Be
            </h3>
            <ul className="space-y-4">
              {PRINCIPLES.map((p) => (
                <li key={p} className="flex items-center gap-3 text-white font-semibold text-sm sm:text-base" data-testid={`manifesto-principle-${p.toLowerCase()}`}>
                  <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 shrink-0" /> {p.toUpperCase()}
                </li>
              ))}
            </ul>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={0.25} className="mt-14 text-center">
          <p className="font-display uppercase text-xl sm:text-2xl lg:text-3xl font-extrabold text-white leading-snug">
            The goal is not to get healthy once. <br />
            <span className="text-gradient-cyan">The goal is to stay healthy for life.</span>
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
};
